import { create } from 'zustand';
import { useUsdRate } from '@/lib/api';
import { Locale, LocaleState } from '@/types/store.types';

interface LocaleActions {
  setLocale: (locale: Locale) => void;
}

type LocaleStore = LocaleState & LocaleActions;

export const useLocaleStore = create<LocaleStore>((set) => ({
  locale: 'mn',

  setLocale: (locale) => set({ locale }),
}));

export const setLocale = (locale: Locale) =>
  useLocaleStore.getState().setLocale(locale);

export function useLocaleWithUsd() {
  const locale = useLocaleStore((state) => state.locale);
  const { data: usdRate } = useUsdRate({ enabled: locale === 'mn' });

  return { locale, usdRate: usdRate ?? null };
}

export type { Locale };
